const ISMOBILE = window.matchMedia("only screen and (max-width: 991px)").matches
const EL = '.js-ReviewsMasonry'

import Masonry from 'masonry-layout';

if(!ISMOBILE && document.querySelector(EL)){
  new Masonry( EL, {
    gutter: 40
  });
}
